module.exports = __webpack_public_path__ + "static/media/header-logo2.a8b217c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo2.svg
// module id = 903
// module chunks = 0